import {saveAllHtml,getTestHtml,updateUserFile,getQuestionHtml,testItemFinish, postQuestion, answerQuestion} from '@/api/api.js';
import { getUUID } from '@/utils/sysUtils'
import { getNowDate,getJsDate  } from '@/utils/dateUtils'
import { objToStr} from '@/utils/sysUtils.js'
import config from '@/config/index.js'

export default {
    created(){
    },
    data() {
        return {
            editFileData:{},      
            docCtl: null  
        }
    },
    methods: {       
        saveFileData(data) {
            data.sendMsg = 0;
            this.$showLoading(); 
            updateUserFile(data).then((res1) => {
                this.$closeLoading();
                if (res1.data.success == true) {
                    if (objToStr(res1.data.result.message) != "") {
                        this.$showToast({msg: res1.data.result.message}) 
                    } else {
                        this.editFileData.content = res1.data.result.content
                        this.$showToast({msg: '操作成功！'}) 
                    }                  
                    this.queryClick();
                } else {
                  this.$showToast({msg: res1.data.message})
                }
            }) 
        },
        insertQuestionConfirm(content) {
            console.log("question", content)
            let newId = getUUID()
            content.id = newId;
            getQuestionHtml(content).then((res) => {
                if (res.data.success == true) {     
                    if  (this.editFileData.content == null) {
                        this.editFileData.content = ""
                    }
                    this.editFileData.content = res.data.message; 
                    this.editFileData.insertContent = 1;
                    let postData = [];
                    let fileId = this.editFileData.id;
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-index", "value":content.index});
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-title", "value": content.title}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-a", "value":content.optionA}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-b", "value":content.optionB}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-c", "value":content.optionC}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-d", "value":content.optionD}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-result", "value": content.result}); 
                    this.saveFileData(this.editFileData);

                    saveAllHtml(postData).then((res) => {
                        if (res.data.success == true) {
                            this.$refs.insertQuestionModal.close();
                            this.queryClick();
                            this.$showToast({
                                msg: '操作成功！' 
                            }) 
                            this.$forceUpdate();
                        } else {
                            this.$showToast({msg: res.data.messeage})
                        }
                    }) 
                } else {
                    this.$showToast({msg: res.data.messeage})
                }
            }) 
        },
        insertTestConfirm(content) {
            console.log("test", content)
            let newId = getUUID()
            let nowDate = getJsDate(getNowDate());
            let creater = sessionStorage.getItem("realname");
            content.id = newId;
            content.date = nowDate;
            content.creater = creater;
            getTestHtml(content).then((res) => {
                if (res.data.success == true) {     
                    if  (this.editFileData.content == null) {
                        this.editFileData.content = ""
                    }
                    this.editFileData.content = res.data.message;
                    this.editFileData.insertContent = 1;                     
                    let postData = [];
                    let fileId = this.editFileData.id;
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-finish", "value":"完成"});
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-status", "value":"未完成"}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-date", "value":nowDate}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-level", "value":content.level}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-duty-person", "value":content.dutyPerson}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-tag", "value":content.tag}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-verno", "value":content.verNo});
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-content", "value":content.content});
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-creater", "value":creater});
                    
                    this.saveFileData(this.editFileData);
                    saveAllHtml(postData).then((res) => {
                        if (res.data.success == true) {
                            this.$refs.insertTestModal.close();
                            this.queryClick();
                            this.$showToast({
                                msg: '操作成功！' 
                            }) 
                            this.$forceUpdate();
                        } else {
                            this.$showToast({msg: res.data.messeage})
                        }
                    }) 
                } else {
                    this.$showToast({msg: res.data.messeage})
                }
            }) 
        },
        insertTimeConfirm(content) {
            console.log("test", content)
            let newId = getUUID()
            let nowDate = getJsDate(getNowDate());
            let creater = sessionStorage.getItem("realname");
            content.id = newId;
            content.date = nowDate;
            content.creater = creater;
            getTestHtml(content).then((res) => {
                if (res.data.success == true) {     
                    if  (this.editFileData.content == null) {
                        this.editFileData.content = ""
                    }
                    this.editFileData.content = res.data.message + objToStr(this.editFileData.content);                     
                    let postData = [];
                    let fileId = this.editFileData.id;
 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "time-item-date", "value":content.date}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "time-item-type", "value":content.type}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-content", "value":content.content}); 
                    postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-times", "value":content.times}); 
                    
                    this.saveFileData(this.editFileData);
                    saveAllHtml(postData).then((res) => {
                        if (res.data.success == true) {
                            this.$refs.insertTestModal.close();
                            this.queryClick();
                            this.$showToast({
                                msg: '操作成功！' 
                            }) 
                            this.$forceUpdate();
                        } else {
                            this.$showToast({msg: res.data.messeage})
                        }
                    }) 
                } else {
                    this.$showToast({msg: res.data.messeage})
                }
            }) 
        },
        
        
    }
};


// WEBPACK FOOTER //
// ./src/mixin/mixinHtml.js